import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../common/DesktopMenu/index";
import MobileMenu from "../../../common/MobileMenu/index";
import useWindowSize from "../../../common/windowSize";
import NewFooter from "../../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getCookie } from "../../../utils/cookie";
import { 
  Background, 
} from "../../../common/Faq/styles";
import { useNavigate } from "react-router-dom";
import {
  SettingsHeader,
  Title,
} from '../styles';
import BackButton from "../../Products/BackButton";
import { toast } from "react-toastify";
import { privateAPI } from "../../../utils/api";
import { CartProductWrapper, TotalPrice } from './styles';
import CartProduct from './Product';
import { HeaderTextButton } from '../../../common/Header/styles';

const Checkout = () => {
  const [userID] = useState(getCookie('userId'));
  const navigate = useNavigate();
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [userCart, setUserCart] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);

  const getUserCart = async () => {
    setLoading(true);
    try {
      const response = await privateAPI.get(`/auth/bacchus/client/cart/${userID}`);
      let listOfCart = [];

      if (response.data.length === 0) {
        navigate("/shop");
      } else {
        const result = response.data.cartProducts.map(async (item) => {
          if(item.quantity) {
            let checkoutProduct = {
              id: item.id,
              quantity: item.quantity,
              image: item.image.slice(0, -1),
              title: item.title,
              sum: item.sum,
              price: item.price
            }
            listOfCart.push(checkoutProduct);
          }
        })
        await Promise.all(result);
        setUserCart(listOfCart);
        setTotalPrice(response.data.totalSum)
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getUserCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel/>
          <Title>
            Checkout
          </Title>
        </SettingsHeader>
        <CartProductWrapper>
          {userCart.map((item, index) => 
            <CartProduct
              key={item.id}
              item={item}
              getUserCart={getUserCart}/>
          )}
        </CartProductWrapper>
        <TotalPrice>
          <h3>Total sum: {totalPrice.toFixed(2)} CHF</h3>
        </TotalPrice>
        <HeaderTextButton cream onClick={() => navigate("/payment-options")}>Go to pay</HeaderTextButton>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default Checkout;
